//      
import React, { Component,           } from 'react';
import { Link } from 'react-router-dom';

import { mergeClassNames } from 'utils/functions';

                   
                                            
                   
                                          
                      
                                                                
                        
                                                             
                 
                                                        
               
                                                 
                  
 

/** A component for a badge. */
export class Badge extends Component             {

    static defaultProps = {
        flavor: 'secondary',
    };

    render() {
        let {
            flavor,
            className,
            children,
            ...domProps
        } = this.props;

        className = mergeClassNames('badge', `badge-${flavor}`, this.props.className);

        let Component = 'span';
        if (domProps.to) {
            Component = Link;
        } else if (domProps.href || domProps.onClick) {
            Component = 'a';
        }

        return React.createElement(
            Component,
            { className, ...domProps},
            children,
        );
    }
}

export default Badge;
